import {Pipe, PipeTransform} from '@angular/core';
import {
    isVoid,
    makeFullExpirationDate,
    makeGuiFriendlyExpirationDate,
    makeGuiFriendlyExpirationDateDte
} from "../utils";

@Pipe({
    name: 'etsFriendlyDatePipe'
})

export class FriendlyDatePipe implements PipeTransform {
    transform(value: string, ...args: any[]): any {

        if (isVoid(value)) {
            return value;
        }

        const isFull = args.length > 0 && args[0] === 'full';
        const isDte = args.length > 0 && args[0] === 'dte';
        // args[1]: optional fromDate (ISO date or datetime) — the "now" the 'full' format's "(Nd)" DTE
        // suffix counts from. QG-history views pass the cursor day; omitted = real wall clock. The pipe
        // is PURE, so a changing fromDate is also what re-runs it when the cursor crosses a day.
        const fromDate = args.length > 1 ? args[1] : undefined;

        let result;

        if (isFull) {
            result = makeFullExpirationDate(value, fromDate);
        } else if (isDte) {
            result = makeGuiFriendlyExpirationDateDte(value);
        } else {
            result =  makeGuiFriendlyExpirationDate(value);
        }

        return result;
    }
}


